import { LOGIN_API, LOGOUT_API } from '~/constants/APIs'
import { ILoginForm, IRefreshTokenForm } from '~/models'
import axiosClient from './axiosClient'

export const authApis = {
  loginUser: (data: ILoginForm) => axiosClient.post(LOGIN_API, data),
  logoutUser: (data: IRefreshTokenForm) => axiosClient.post(LOGOUT_API, data) as unknown
}
